<template>
  <b-navbar toggleable style="background-color: #0b1427" type="dark" class="p-0">
    <b-navbar-brand v-if="hideCentralLogo" >
      <div class="d-inline navigate" @click="navigateToHome">
        <img src="@/assets/imgs/logo.png" class="img-fluid" alt="Logo Inventech" width="60">
      </div>
      <span class="text-white pl-4" v-if="selectedProject">{{ selectedProject.name }}</span>
    </b-navbar-brand>
    <router-link :to="`/${$i18n.locale}/principal-page`" class="mx-auto" v-if="!hideCentralLogo" :class="isAuthenticated ? 'padding-authenticated' : 'padding-unauthenticated'">
      <img
        :src="require('@/assets/imgs/logoInventech.png')"
        width="180"
        class="img-fluid"
      />
    </router-link>
    <div class="d-flex justify-content-between navbar-btn" >
      <!-- <img src="@/assets/svg/s.svg" class="img-fluid px-2" alt="Logo Inventech" >
      <img src="@/assets/svg/v.svg" class="img-fluid px-3" alt="Logo Inventech" >  -->
      <b-dropdown size="sm" variant="link" toggle-class="text-decoration-none dropdown-lang" no-caret :title="$t('navbar.lang')" :style="{ 'margin-right': isAuthenticated ? '0' : '19px' }">
        <template #button-content>
          <img src="@/assets/imgs/iconoIdiomas.png" class="img-fluid " alt="Lang icon" width="24">
        </template>
        <b-dropdown-item @click.prevent="setLocale('pt')">PT</b-dropdown-item>
        <b-dropdown-item @click.prevent="setLocale('es')">ES</b-dropdown-item>
        <b-dropdown-item @click.prevent="setLocale('en')">EN</b-dropdown-item>
      </b-dropdown>
      <UserProfile v-if="isAuthenticated" />
    </div>
  </b-navbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { EventBus } from "@/main.js";
import UserProfile from "@/views/user/UserProfile.vue";
import Swal from "sweetalert2";
export default {
  components: {
    UserProfile
  },
  data() {
    return {
      hideCentralLogo: false,
      isProjectName: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapGetters('projects', ['selectedProject']),
  },
  watch: {
    "$route.fullPath": {
      handler: function(newPath) {
        // Verifica si la ruta actual es la página de perfil
        this.hideCentralLogo = newPath.includes("/create-project/") ||
          newPath.includes("/board") ||
          newPath.includes("/projects") ||
          newPath.includes("/academy") ||
          newPath.includes("/home");
        this.isProjectName = newPath.includes("/board/");
      },
      immediate: true,
    },
   '$route.params.id': 'loadProject'
  },
  created() {
    this.loadProject();
  },
  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('projects', ['fetchProjectById','deselectProject']),
    async loadProject() {
      const projectId = this.$route.params.id;
      if (projectId) {
        await this.fetchProjectById(projectId);
      } else {
        this.deselectProject();
      }
    },
    setLocale(locale) {
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale;
        this.$router.push({
          params: { lang: locale }
        });
      }
    },
    navigateToHome() {
      // Redirige a la vista de home
      if (this.$route.path != `/${this.$i18n.locale}/home`) {
        this.$router.push(`/${this.$i18n.locale}/home`);
      }
    },
    closeComponents() {
      // Cierra el b-modal si está abierto
      EventBus.$emit('close-modal');
      EventBus.$emit('close-sidebar');
      // Aquí puedes agregar más lógica para cerrar otros componentes si es necesario
    },
    async onLogout() {
      const result = await Swal.fire({
        title: this.$t('logout.title'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t('logout.yes'),
        cancelButtonText: this.$t('logout.no'),
      });

      if (result.isConfirmed) {
        try {
          await this.logout();
          this.$router.push(`/${this.$i18n.locale}/principal-page`);
        } catch (error) {
          console.error('Failed to logout:', error);
          Swal.fire(
            'Error',
            'Hubo un problema al cerrar la sesión. Por favor, inténtalo de nuevo.',
            'error'
          );
        }
      }
    },
  },
};
</script>
<style>
.navbar-btn .btn:focus, .btn.focus {
  box-shadow: 0 0 0 0;
}
</style>
<style scoped>
.navigate {
  cursor: pointer;
}
.padding-authenticated {
  padding-left: 120px;
}

.padding-unauthenticated {
  padding-left: 88px;
}
</style>
